import React from 'react';
import './styles/UI.css';

const LoadingOverlay = ({ message = "Finding your location..." }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-spinner">{message}</div>
    </div>
  );
};

export default LoadingOverlay; 